//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'AgencyExcursionPlaces',
  components: {
    RoundButton: () => import('@/components/common/RoundButton'),
    Icon24FillEdit: () => import('@/assets/icons/Icon24FillEdit.svg?inline'),
    AgencyPlacesCard: () => import('@/components/common/AgencyPlacesCard')
  },
  layout: 'personal-area-agency',
  data () {
    return {
      titles: [
        this.$t('components.agency-excursion-places.title-image'),
        this.$t('components.agency-excursion-places.title-name'),
        this.$t('components.agency-excursion-places.title-address'),
        this.$t('components.agency-excursion-places.title-rating'),
        this.$t('components.agency-excursion-places.title-status')
      ]
    }
  },
  computed: {
    ...mapGetters({
      excursion: 'account-agency-excursion/excursion',
      trip: 'account-agency-excursion/excursion'
    }),
    places () {
      return this?.excursion?.places?.length > 0 ? this?.excursion?.places : []
    }
  },
  methods: {
    openPopup () {
      this.$store.commit('popup/open', {
        name: 'PopupAddExcursion',
        params: {
          style: {
            width: '632px',
            maxHeight: '100vh'
          }
        },
        options: this?.trip
      })
    }
  }
}
